/**
 * author： blake.li
 * createDate: 2020-01-14
 * description: 环境判断
 */
import {getCookie} from '../utils';

// 去哪app大客户端
function isQunarApp() {
    return (hysdk && hysdk.sniff && hysdk.sniff.qunar) || navigator.userAgent.toLowerCase().indexOf('qunar') > -1;
}

// 去哪app大客户端 ios
function isQunarAppIos() {
    return isQunarApp() && hysdk.sniff.ios;
}

// 去哪app大客户端 android
function isQunarAppAdr() {
    return isQunarApp() && hysdk.sniff.android;
}

// 微信
function isWx() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1;
}

//微信小程序
function isWxApp() {
    let isMiniProgram = isWx() && navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1;
    return isMiniProgram || window.__wxjs_environment === 'miniprogram';
}

// 机票微信小程序
function isFlightWxApp() {
    return isWxApp() && judgeByQN621('wx_app_flight');
}

// 去哪儿公共微信小程序
function isQunarWxApp() {
    return isWxApp() && judgeByQN621('wx_app_qunar');
}

// 去哪儿公共百度小程序 （目前机票的百度小程序集成在了公共小程序内）
function isQunarBuApp() {
    return judgeByQN621('bu');
}

// 通过QN621判断通用方法
function judgeByQN621(str) {
    let cookieStr = getCookie('QN621');
    return !!(cookieStr && cookieStr.indexOf(str) > -1);
}

// 通过QN621判断通用方法
function getClientType() {
    let clientType = '';
    if (isQunarApp()) {
        clientType = 'app';
    } else if (isWxApp()) {
        clientType = 'wx';
    } else {
        clientType = 'touch';
    }
    return clientType;
}

export {
    isQunarApp,
    isQunarAppIos,
    isQunarAppAdr,
    isWx,
    isWxApp,
    isFlightWxApp,
    isQunarWxApp,
    isQunarBuApp,
    getClientType
};
